import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/client';
import { useTranslation } from 'react-i18next';
import { MessageCircle, User } from 'lucide-react';

export default function Matches() {
  const navigate = useNavigate();
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/matches').then((r) => setMatches(r.data || [])).catch(console.error).finally(() => setLoading(false));
  }, []);

  return (
    <div className="h-full flex flex-col" data-testid="matches-page">
      <header className="px-8 py-6" style={{borderBottom:'1px solid var(--border-color)'}}>
        <h1 className="text-2xl font-black" style={{color:'var(--text-primary)'}}>Matchs & Messages</h1>
        <p className="text-sm mt-1" style={{color:'var(--text-muted)'}}>{matches.length} match{matches.length !== 1 ? 's' : ''}</p>
      </header>

      <div className="flex-1 overflow-y-auto p-6">
        {loading ? (
          <div className="flex justify-center py-20"><div className="w-8 h-8 border-2 border-brand-violet border-t-transparent rounded-full animate-spin" /></div>
        ) : matches.length === 0 ? (
          <div className="text-center py-20">
            <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4" style={{background:'var(--bg-card)'}}><MessageCircle size={32} style={{color:'var(--text-faint)'}} /></div>
            <p className="text-lg font-semibold mb-2" style={{color:'var(--text-secondary)'}}>Aucun match pour le moment</p>
            <p className="text-sm" style={{color:'var(--text-muted)'}}>Allez decouvrir de nouveaux profils !</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {matches.map((match) => {
              const other = match.other_user;
              return (
                <div key={match.id} onClick={() => navigate(`/chat/${match.id}`)}
                  className="glass-card-hover p-4 cursor-pointer flex items-center gap-4"
                  data-testid={`match-card-${match.id}`}
                >
                  <div className="w-14 h-14 rounded-full overflow-hidden shrink-0" style={{background:'var(--bg-card)'}}>
                    {other?.photos?.[0] ? (
                      <img src={other.photos[0]} alt={other.name} className="w-full h-full object-cover" />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center"><User size={24} style={{color:'var(--text-faint)'}} /></div>
                    )}
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="font-bold text-sm truncate" style={{color:'var(--text-primary)'}}>{other?.name || 'Utilisateur'}, {other?.age}</p>
                    <p className="text-xs mt-0.5" style={{color:'var(--text-muted)'}}>Cliquez pour discuter</p>
                  </div>
                  <MessageCircle size={18} className="text-brand-violet shrink-0" />
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
